import "../../../../design/waiting.css";
import {logout} from "../../../../utils/functions/multiUseFunctions";

export default function Waiting({personId}) {

    return (
        <div className="waitingWrapper">
            <div className="waitingCard">

                <div className="waitingIcon">⏳</div>

                <h2 className="waitingTitle">მოთხოვნა მუშავდება</h2>

                <p className="waitingText">
                    ანგარიშზე პირადი ნომრით <strong>{personId}</strong> მიმდინარეობს
                    თქვენი ინფორმაციის გადამოწმება.
                </p>

                <p className="waitingSubText">
                    თუ ინფორმაცია სწორია, თქვენი ანგარიში მალე გააქტიურდება.
                </p>

                <p className="waitingSubText muted">
                    წინააღმდეგ შემთხვევაში მოთხოვნა გაუქმდება ადმინისტრაციის მიერ.
                </p>

                <button
                    className="waitingButton"
                    onClick={logout}
                >
                    მთავარ გვერდზე დაბრუნება
                </button>

            </div>
        </div>
    );
}